/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Nav_LotsInputs */

const vi_pl_nav_lots = /** @type {(inputs: Pl_Nav_LotsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách lô`)
};

/**

* @param {Pl_Nav_LotsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_nav_lots = /** @type {((inputs?: Pl_Nav_LotsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Nav_LotsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_nav_lots(inputs)
});